import React from 'react';
import { Button, Popover } from 'antd';
import styles from './CitationGroup.module.scss';

// Runs longer than this collapse to the first citation plus a "+n" chip.
const COLLAPSE_THRESHOLD = 2;

const CitationGroup: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const items = React.Children.toArray(children);

  if (items.length <= COLLAPSE_THRESHOLD) {
    return <>{items}</>;
  }

  const hidden = items.slice(1);

  return (
    <>
      {items[0]}
      <Popover
        open={open}
        onOpenChange={setOpen}
        trigger="click"
        content={<span className={styles.moreList}>{hidden}</span>}
      >
        <Button
          size="small"
          className={styles.moreButton}
          aria-label={`Show ${hidden.length} more citations`}
        >
          +{hidden.length}
        </Button>
      </Popover>
    </>
  );
};

export default CitationGroup;
